<script>
    import Helper from '../_common/helper.svelte'
    import Fa from 'svelte-fa'
    import { faFrown, faMeh, faSmile, faLink, faUnlink, faStar, faStarHalf } from '@fortawesome/free-solid-svg-icons'
    import { onMount } from 'svelte'
    import { NPS } from '../../modules/toolsApi/nps/nps/nps'
    import { NPSRepository } from '../../modules/toolsApi/nps/nps/nps.repository'
    import { NPSService } from '../../modules/toolsApi/nps/nps/nps.service'
    import { navigateTo } from 'yrv'
    import { Review } from '../../modules/toolsApi/nps/reviews/review'
    import { ReviewsRepository } from '../../modules/toolsApi/nps/reviews/reviews.repository'
    import { ReviewsService } from '../../modules/toolsApi/nps/reviews/reviews.service'
    import { ReviewType } from '../../modules/toolsApi/nps/reviews/reviews.enum'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    import Zframe from '../_common/z/zframe.svelte'
    dayjs.extend(utc)

    const entityRep = new NPSRepository()
    const entityS = new NPSService(entityRep)
    const reviewRep = new ReviewsRepository()
    const reviewS = new ReviewsService(reviewRep)

    let npsNote = 0
    let totalToPercent = 0
    let score = []
    let totalReviews = 0
    let entity = new NPS()
    let reviews = []
    let show = true
    let hide10 = false

    onMount(async () => {
        await loadNPS()
        await loadReviews()
        await updateGoogle(true)
    })

    async function loadNPS() {
        entity = await entityS.getAll() // a api retorna no getall o token da empresa atual apenas (objeto, não array)
    }

    async function updateGoogle(silent = false) {
        try {
            entity = await entityS.updateGoogle(entity.npsId)
            console.log('result', entity)
        } catch (error) {
            if (!silent && error.toString().includes('Many requests')) {
                window.alert('Os dados já foram atualizados recentemente.\nTente novamente em 1 ou 2 dias.')
            }
            console.log('error', error)
        }
    }

    async function loadReviews() {
        try {
            show = true
            // type nps: a lista e o calculo abaixo usam a escala 0-10, as avaliacoes do Google sao 1-5
            reviews = await reviewS.getAll({ type: ReviewType.nps })
            let notes = await reviewS.notes()
            for (const note of Array(11).keys()) {
                score.push(notes?.find((el) => el.rating === note)?._count?.rating || 0)
            }
            score = score
            totalReviews = score.reduce((total, num) => total + num)
        } catch (error) {
        } finally {
            show = false
        }
    }

    async function showConfiguration() {
        navigateTo('/nps/config')
    }

    $: {
        let detractors = score.reduce((previous, current, i) => {
            if (i < 7) {
                return previous + current
            } else {
                return previous
            }
        }, 0)
        let promoters = score.reduce((previous, current, i) => {
            if (i >= 9) {
                return previous + current
            } else {
                return previous
            }
        }, 0)
        let total = score.reduce((previous, current, i) => {
            return previous + current
        }, 0)
        npsNote = Math.round(((promoters - detractors) / total) * 100)
        totalToPercent = Math.round((npsNote / 200) * 100) + 50
    }
</script>

{#if !show}
    {#if (!show && !entity?.npsId) || entity?.status === 0}
        <div class="root-info mb-5">
            <Helper
                image="/img/automation.png"
                title="Pesquisa NPS e Estrelas no Google"
                text="NPS é o indicador mais utilizado no mundo para medir a satisfação de clientes. As Estrelas (avaliações) do Google são um fator decisivo na tomada de decisão de compra."
                list={[
                    'Realize pesquisas NPS automaticamente com o Zandu',
                    'Conecte o Zandu com o Google Meu Negócio e melhore sua avaliação pública (estrelas) automaticamente',
                    'Receba feedback de seus clientes e melhore cada vez mais seu atendimento',
                ]}
            >
                {#if window.store.token.permissions.nps.nps.write}
                    <button on:click={showConfiguration}>Configurar meu NPS</button>
                {/if}
            </Helper>
        </div>
    {:else}
        <div class="root-info m-bottom-sm">
            <Zframe
                title="Zandu NPS - Net Promoter Score"
                headline="NPS é o indicador mais utilizado no mundo para medir a satisfação de clientes. Por ser um método padronizado internacionalmente você pode comparar seu resultado com o de outras empresas iguais à sua."
            >
                <div class="config-box">
                    <div class="-title h-full">Seu NPS atual</div>
                    {#if isNaN(npsNote) || totalReviews < 10}
                        <div class="no-nps">
                            Você ainda não recebeu avaliações suficientes para que o NPS seja calculado.<br />Ao atingir 10 avaliações seu NPS aparecerá aqui.
                            Você já recebeu {totalReviews} avaliações.
                        </div>
                    {:else}
                        <div class="nps-total">
                            <div class="slider">
                                <div class="circle" style="margin-left: calc({totalToPercent}% - 35px);">
                                    <div class="total">{npsNote}</div>
                                    <!-- <div class="label">Seu NPS</div> -->
                                    <div class="arrow-down" />
                                </div>
                            </div>

                            <div class="info">
                                <div class="a">-100</div>
                                <div class="b">0</div>
                                <div class="c">100</div>
                            </div>
                            <div class="label-bar">
                                <div class="a">Precisa melhorar</div>
                                <div class="b">Bom</div>
                                <div class="c">Ótimo</div>
                                <div class="d">Excelente</div>
                            </div>
                        </div>

                        <div class="-title mt-4">Total de avaliações por nota</div>
                        <div class="nps-bar">
                            <div class="block detractors">
                                <div class="items">
                                    {#each score as detractor, i}
                                        {#if i < 7}
                                            <div class="item">
                                                <div class="value">{i}</div>
                                                <Fa color="#e34641" icon={faFrown} />
                                                <div class="total">{detractor}</div>
                                            </div>
                                        {/if}
                                    {/each}
                                </div>
                                <div class="label">Detratores</div>
                            </div>
                            <div class="block passives">
                                <div class="items">
                                    {#each score as passive, i}
                                        {#if i >= 7 && i < 9}
                                            <div class="item">
                                                <div class="value">{i}</div>
                                                <Fa color="#ea9635" icon={faMeh} />
                                                <div class="total">{passive}</div>
                                            </div>
                                        {/if}
                                    {/each}
                                </div>
                                <div class="label">Passivos</div>
                            </div>
                            <div class="block promoters">
                                <div class="items">
                                    {#each score as promoter, i}
                                        {#if i >= 9}
                                            <div class="item">
                                                <div class="value">{i}</div>
                                                <Fa color="#23b272" icon={faSmile} />
                                                <div class="total">{promoter}</div>
                                            </div>
                                        {/if}
                                    {/each}
                                </div>
                                <div class="label">Promotores</div>
                            </div>
                        </div>
                    {/if}
                </div>
                <div class="link-box">
                    {#if entity?.googleOn}
                        <div class="on">
                            <Fa size="3x" icon={faLink} />
                            <div class="label">Seu NPS está conectado com o Google e trabalhando para melhorar a avaliação pública.</div>
                        </div>
                    {:else}
                        <div class="off">
                            <Fa size="3x" icon={faUnlink} />
                            <div class="label">NPS desconectado. Conecte seu NPS ao Google para melhorar a avaliação pública.</div>
                        </div>
                    {/if}
                </div>

                <div class="config-box google-box">
                    <div class="-title">Google Meu Negócio</div>
                    <div class="intro-label">
                        <p>A nota do Google Meu Negócio aparece publicamente sempre que alguém pesquisa na Internet por sua empresa ou serviços.</p>
                        <p>
                            Os usuários geralmente olham por <b>quantidade de avaliações</b> e
                            <b>notas iguais ou superiores a 4.2</b>
                        </p>
                    </div>
                    <div class="-title h-full">Avaliação de sua empresa no Google</div>
                    {#if entity?.googleRankCurrent === null}
                        <div class="no-nps">Estamos coletando os dados de sua empresa. Volte dentro de algumas horas.</div>
                    {:else}
                        <div class="google-rank">
                            <div class="-before">
                                <div class="label">Antes:</div>
                                <div class="data">
                                    <div class="rank">{entity?.googleRankInitial}</div>
                                    <div class="stars">
                                        {#each [0.3, 1.3, 2.3, 3.3, 4.3] as star}
                                            {#if entity?.googleRankInitial >= star}
                                                {#if entity?.googleRankInitial >= star + 0.7 || entity?.googleRankInitial % 1 >= 0.79}
                                                    <Fa color="#999" size="1x" icon={faStar} />
                                                {:else}
                                                    <Fa color="#999" size="1x" icon={faStarHalf} />
                                                {/if}
                                            {:else}
                                                <Fa color="#99999930" size="1x" icon={faStar} />
                                            {/if}
                                        {/each}
                                    </div>
                                    <div class="total">
                                        (<b>{entity?.googleReviewsInitial}</b>)
                                    </div>
                                </div>
                                <!-- {#if entity?.googleReviewsCurrent - entity?.googleReviewsInitial > 1 && entity?.googleRankCurrent - entity?.googleRankInitial > 0}
                            <br />Sua nota passou de {entity?.googleRankInitial} para <b>{entity?.googleRankCurrent}</b>
                            e você recebeu
                            <b>{entity?.googleReviewsCurrent - entity?.googleReviewsInitial}</b> novas avaliações após conectar
                            o Zandu NPS ao Google.
                            {/if} -->
                            </div>
                            <div class="-after">
                                <div class="label">Recente*:</div>
                                <div class="data">
                                    <div class="rank">{entity?.googleRankCurrent}</div>
                                    <div class="stars">
                                        {#each [0.3, 1.3, 2.3, 3.3, 4.3] as star}
                                            {#if entity?.googleRankCurrent >= star}
                                                {#if entity?.googleRankCurrent >= star + 0.7 || entity?.googleRankCurrent % 1 >= 0.79}
                                                    <Fa color="#ea9635" size="1x" icon={faStar} />
                                                {:else}
                                                    <Fa color="#ea9635" size="1x" icon={faStarHalf} />
                                                {/if}
                                            {:else}
                                                <Fa color="#99999930" size="1x" icon={faStar} />
                                            {/if}
                                        {/each}
                                    </div>
                                    <div class="total">
                                        (<b>{entity?.googleReviewsCurrent}</b>)
                                    </div>
                                    <div class="act">
                                        <a href={entity?.googleURL} target="_blank">Ver</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-muted text-end info-last-refresh">
                            *Última atualização: {dayjs(entity.googleDateCurrent).format('DD/MM/YYYY HH:mm:ss')}
                        </div>
                    {/if}
                    <!-- <div class="config-box box-refresh">
                        <div>
                            *Última atualização: {dayjs(entity.googleDateCurrent).format('DD/MM/YYYY HH:mm:ss')}
                        </div>
                        <button class="btn btn-secondary btn-sm" on:click={() => updateGoogle()}>Atualizar agora</button
                        >
                    </div> -->
                </div>
            </Zframe>
            <Zframe title="Comentários dos clientes" class="mt-3">
                <div class="box-comments">
                    <div class="intro-label">
                        <p>
                            Aos clientes que avaliaram sua empresa com uma nota abaixo de 10 perguntamos:<br />
                            <i>"O que podemos fazer para merecer de você um 10 da próxima vez?"</i>
                        </p>
                        <div class="show-all">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="noemail" bind:checked={hide10} />
                                <label class="form-check-label" for="noemail">Ocultar avaliações com nota máxima</label>
                            </div>
                        </div>
                        {#if reviews.length === 0}
                            <div class="no-nps">Quando seus clientes começarem a responder as respostas aparecerão aqui.</div>
                        {/if}
                    </div>
                    <div class="comments">
                        {#each reviews as review}
                            {#if !hide10 || review.rating < 10}
                                <div class="comment">
                                    <div class="comment-icon">
                                        <div class="rating">{review.rating}</div>
                                    </div>
                                    <div class="comment-review">
                                        {#if !!review.text}
                                            <div class="text">
                                                {review.text || '-'}
                                            </div>
                                        {/if}
                                        <div class="info">
                                            Por {review.authorName} em {dayjs(review.updatedAt).utc().format('DD/MM/YYYY')}
                                        </div>
                                    </div>
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>
            </Zframe>
        </div>
    {/if}
{/if}

<style>
    p {
        margin-bottom: 12px;
    }
    .root-info {
    }

    .intro-label {
        opacity: 0.8;
        font-weight: 300;
    }

    .root-info .-title {
        font-size: 22px;
        font-weight: 300;
        text-align: center;
        padding-bottom: 8px;
    }
    .config-box {
        padding: 8px;
        border-radius: 6px;
        border: 1px solid #99999920;
        background: #9999990c;
    }
    .no-nps {
        text-align: center;
        opacity: 0.85;
        margin: 8px 0px;
    }
    .nps-bar {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
    }
    .nps-bar .block .items {
        display: flex;
        margin: 0px 6px;
    }
    .nps-bar .block .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0px 4px;
    }
    .nps-bar .block .item .value {
        border: 2px solid #99999940;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border-bottom: 3px solid #99999940;
        margin-bottom: 8px;
    }
    .nps-bar .block .item .total {
        margin: 8px 0px;
        padding: 0px 4px;
        border-radius: 24px;
        align-self: stretch;
        display: flex;
        justify-content: center;
    }
    .nps-bar .block .label {
        text-align: center;
        font-size: 13px;
    }
    .nps-bar .detractors .item .value {
        color: #e34641;
    }
    .nps-bar .passives .item .value {
        color: #ea9635;
    }
    .nps-bar .promoters .item .value {
        color: #23b272;
    }

    .nps-bar .detractors .item .total {
        background: #e3464166;
    }
    .nps-bar .passives .item .total {
        background: #ea963566;
    }
    .nps-bar .promoters .item .total {
        background: #23b27266;
    }

    .nps-bar .detractors .items {
        border-bottom: 2px solid #e3464166;
    }
    .nps-bar .passives .items {
        border-bottom: 2px solid #ea963566;
    }
    .nps-bar .promoters .items {
        border-bottom: 2px solid #23b27266;
    }
    .nps-total {
        margin-top: 16px;
    }
    .nps-total .slider {
        padding: 0px 50px;
    }
    .nps-total .circle {
        border-bottom: 0px solid #99999960;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px;
        flex-direction: column;
        position: relative;
        margin-left: calc(100% - 50px);
        background: #99999910;
        border-radius: 4px;
        width: 70px;
    }
    .nps-total .total {
        font-size: 40px;
    }
    .circle .arrow-down {
        border: solid #99999960;
        border-width: 0px 3px 3px 0px;
        display: inline-block;
        padding: 4px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        position: absolute;
        margin-top: 89px;
    }
    .nps-total .info {
        width: 100%;
        padding: 0px 50px;
        display: flex;
        color: #99999999;
        font-size: 12px;
    }
    .nps-total .info > div {
        flex: 1 1 0px;
    }
    .nps-total .info .a {
        text-align: left;
    }
    .nps-total .info .b {
        text-align: center;
    }
    .nps-total .info .c {
        text-align: right;
    }
    .nps-total .label-bar {
        width: 100%;
        padding: 0px 50px;
        display: flex;
    }
    .nps-total .label-bar > * {
        text-align: center;
        font-size: 13px;
    }
    .nps-total .label-bar .a {
        border-top: 8px solid #e34641;
        width: 50%;
    }
    .nps-total .label-bar .b {
        border-top: 8px solid #ea9635;
        width: 15%;
    }
    .nps-total .label-bar .c {
        border-top: 8px solid #34c383;
        width: 20%;
    }

    .nps-total .label-bar .d {
        border-top: 8px solid #12a161;
        width: 15%;
    }

    .link-box {
        border: 0px;
        margin: -12px 0px -12px 0px;
        padding: 8px;
    }
    .link-box > * {
        flex: 0 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .link-box .on {
        color: #34c383;
    }
    .link-box .off {
        color: #fba746;
    }
    .link-box .label {
        opacity: 0.8;
        font-size: 13px;
        margin-left: 8px;
        line-height: 1.2;
    }

    .google-box .google-rank {
        display: flex;
        justify-content: center;
        gap: 16px;
        flex-wrap: wrap;
    }
    .google-box .google-rank > div {
        display: flex;
        background: white;
        padding: 0px 0px;
        align-items: stretch;
    }
    .google-box .google-rank .data {
        display: flex;
        justify-content: center;
    }
    .google-box .google-rank .-before {
        flex: 0 1 360px;
    }
    .google-box .google-rank .-after {
        flex: 0 1 360px;
    }
    .google-box .google-rank .label {
        color: #eee;
        background-color: #666;
        padding: 0px 8px;
        display: flex;
        align-items: center;
        flex: 0 0 82px;
    }
    .google-box .google-rank .-after .label {
        background: #12a161;
    }
    .google-box .google-rank .data {
        display: flex;
        align-items: center;
        padding: 8px 2px 8px 4px;
        flex-grow: 1;
    }
    .google-box .data .rank {
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        margin-right: 8px;
        background: #999;
    }
    .google-box .-after .data .rank {
        background: #12a161;
    }
    .google-box .data .stars {
        text-align: center;
    }
    .google-box .data .total {
        color: #999;
        margin-left: 8px;
    }
    .google-box .-after .data .total {
        color: #ea9635;
        flex-grow: 1;
    }
    .google-box .data .total b {
        font-size: 18px;
    }
    .google-box .-after .data .act {
        padding: 0px 4px;
        text-align: center;
    }
    .google-box .-after .data .act a {
        color: blue;
        margin-left: 8px;
    }

    .comments {
    }
    .comment {
        display: flex;
        align-items: center;
        padding-bottom: 8px;
        margin-top: 8px;
        border-bottom: 1px solid #99999922;
    }
    .comment .comment-icon {
        display: flex;
        align-items: center;
        overflow: hidden;
        padding-right: 8px;
        flex: 0 0 auto;
    }
    .comment .comment-icon .rating {
        background: #333;
        color: #fff;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        font-size: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .comment .comment-review {
        flex-grow: 1;
    }
    .comment .comment-review .text {
        font-size: 15px;
    }
    .comment .comment-review .info {
        color: #888;
        font-size: 14px;
    }
    .show-all {
        margin-bottom: 16px;
    }

    .info-last-refresh {
        font-size: 14px;
        padding-right: 8px;
        padding-top: 8px;
    }

    .nps-bar :global(.block .item svg) {
        font-size: 36px;
    }

    @media (max-width: 900px) {
        .nps-bar .block .item {
            font-size: 13px;
            margin-left: 2px !important;
            margin-right: 2px !important;
        }
        .nps-bar :global(.block .item svg) {
            font-size: 18px;
        }
        .nps-bar .block .item .value {
            border: 1px solid #99999940 !important;
            width: 26px !important;
            height: 26px !important;
        }
    }
</style>
